import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
// import { adminMainUrl } from '../../../Config';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
// import Skeleton from 'react-loading-skeleton'
// import Api from '../../../Api';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import Beatloader from '../../../Common/Loaders/Beatloader';
import { getPricingLeadStatus } from '../../../Redux/action/Pricing/PricingLeadStatusAction';
import EditQuoteForm from '../../SalesCrm/modal/EditQuoteForm';
import { adminMainUrl } from '../../../Config';
import { capitalizeFirstLetter } from '../../../HelperFunctions';
import { getHrmsBranchList } from '../../../Redux/action/Organisation/Branch/BranchAction';

const PricingQuoteList = ({ identifier, showTabs, showRepricingTabs, headingText, resetURL, shipment_mode, usertype, showSideNavBar }) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }

    const navigate = useNavigate();
    const [grid, setGrid] = useState(true)
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [status_id, setStatus_id] = useState('');
    const [id, setId] = useState(null)
    let [list, setList] = useState([]);
    const [isResetting, setIsResetting] = useState(false);
    const fromDate = startDate ? formatDate(startDate) : null;
    const toDate = endDate ? formatDate(endDate) : null;
    const [count, setCount] = useState(1);
    const [requiredServiceData, setRequiredServiceData] = useState('')
    const [filterTab, setFilterTab] = useState("all");


    const [requestedCount, setRequestedCount] = useState(0);
    const [myQuotesCount, setMyQuotesCount] = useState(0);
    const [inProcessCount, setInProcessCount] = useState(0);
    const [sentCount, setSentCount] = useState(0);
    const [repricingCount, setRepricingCount] = useState(0);
    const dispatch = useDispatch();
    const token = Cookies.get("token");
    const user_id = Cookies.get("flexichain_user_id");
    const { HrmsBranchList } = useSelector(state => state?.BranchReducer || {});
    const { sidebarPermissionHRMSData } = useSelector(state => state?.NavbarReducer || {});

    const hasFilterPermission = sidebarPermissionHRMSData?.role_id == sidebarPermissionHRMSData?.user_id;

    const branchList = HrmsBranchList && Array.isArray(HrmsBranchList) ? HrmsBranchList.map((item) => ({
        value: item.branch_id,
        label: item.branch_name,
    })) : [];

    const applyStatusCounts = (counts) => {
        if (!counts) return;
        if (shipment_mode === "air") {
            if (usertype === "import") {
                setRequestedCount(counts?.airImportRequest ?? 0);
                setInProcessCount(counts?.airImportInprocess ?? 0);
                setSentCount(counts?.airImportSent ?? 0);
                setRepricingCount(counts?.airImportRepricing ?? 0);
            } else if (usertype === "export") {
                setRequestedCount(counts?.airExportRequest ?? 0);
                setInProcessCount(counts?.airExportInprocess ?? 0);
                setSentCount(counts?.airExportSent ?? 0);
                setRepricingCount(counts?.airExportRepricing ?? 0);
            }
        } else if (shipment_mode === "ocean") {
            if (usertype === "import") {
                setRequestedCount(counts?.oceanImportRequest ?? 0);
                setInProcessCount(counts?.oceanImportInprocess ?? 0);
                setSentCount(counts?.oceanImportSent ?? 0);
                setRepricingCount(counts?.oceanImportRepricing ?? 0);
            } else if (usertype === "export") {
                setRequestedCount(counts?.oceanExportRequest ?? 0);
                setInProcessCount(counts?.oceanExportInprocess ?? 0);
                setSentCount(counts?.oceanExportSent ?? 0);
                setRepricingCount(counts?.oceanExportRepricing ?? 0);
            }
        } else if (shipment_mode === "courier") {
            if (usertype === "import") {
                setRequestedCount(counts?.courierImportRequest ?? 0);
                setInProcessCount(counts?.courierImportInprocess ?? 0);
                setSentCount(counts?.courierImportSent ?? 0);
                setRepricingCount(counts?.courierImportRepricing ?? 0);
            } else if (usertype === "export") {
                setRequestedCount(counts?.courierExportRequest ?? 0);
                setInProcessCount(counts?.courierExportInprocess ?? 0);
                setSentCount(counts?.courierExportSent ?? 0);
                setRepricingCount(counts?.courierExportRepricing ?? 0);
            }
        }
    };

    const fetchMyQuotesCount = async () => {
        try {
            if (!token || !user_id || !shipment_mode || !usertype) return;
            const res = await fetch(`${adminMainUrl}/api/pricing/my-quote-list?page=1&limit=1`, {
                method: "POST",
                headers: {
                    "auth-token": token,
                    "user_id": user_id,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    shipment_mode: shipment_mode,
                    quotation_user_type: usertype === "import" ? "IMPORTER" : "EXPORTER",
                }),
            });
            const resData = await res.json();
            if (resData?.pagination?.totalRecords !== undefined) {
                setMyQuotesCount(resData.pagination.totalRecords);
            }
        } catch (error) {
            console.log("Error fetching my quotes count:", error);
        }
    };

    const fetchAllOtherCounts = async () => {
        try {
            if (!token || !user_id || !shipment_mode || !usertype) return;
            const res = await fetch(`${adminMainUrl}/api/pricing/requested-quote-list?page=1&limit=1`, {
                method: "POST",
                headers: {
                    "auth-token": token,
                    "user_id": user_id,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    shipment_mode: shipment_mode,
                    quotation_user_type: usertype === "import" ? "IMPORTER" : "EXPORTER",
                }),
            });
            const resData = await res.json();
            if (resData?.getCount) {
                applyStatusCounts(resData.getCount);
            }
        } catch (error) {
            console.log("Error fetching all other counts:", error);
        }
    };

    useEffect(() => {
        if (token && user_id) {
            dispatch(getHrmsBranchList(token, user_id));
            fetchMyQuotesCount();
            if (identifier?.includes("-my-quotes")) {
                fetchAllOtherCounts();
            }
        }
    }, [token, user_id, shipment_mode, usertype, identifier]);

    const location = useLocation();
    const quotationId = location ? location?.state ? location?.state?.quotationId : null : null;

    useEffect(() => {
        // Assuming 'quotationId' is part of your state or props
        const hasQuotationId = quotationId; // replace `state` with wherever your state is coming from
        if (hasQuotationId) {
            setFilterTab(`${hasQuotationId}`);
            setCount(1)
        }

    }, [quotationId]);
    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    useEffect(() => {
        if (isResetting) {
            setIsResetting(false);  // Reset the flag after fetching quotations
        }
    }, [isResetting]);




    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
        { title: "Date", dataIndex: "date", key: "date" },
        { title: "Name", dataIndex: "name", key: "name" },
        { title: "Email", dataIndex: "email", key: "email" },
        { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
        { title: "Origin", dataIndex: "origin", key: "origin" },
        { title: "Destination", dataIndex: "destination", key: "destination" },
        { title: "Service Type", dataIndex: "serviceType", key: "serviceType" },
        { title: "Shipment Mode", dataIndex: "shipmentMode", key: "shipmentMode" },
        // { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
        { title: "Sales Person", dataIndex: "pickedBySales", key: "pickedBySales" },
        { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];


    const [query, setQuery] = useState("");
    const [pageLoader, setPageLoader] = useState(false);
    const [dataSourcer, setDataSourcer] = useState(false);
    const [currentPage, setCurrentPage] = useState(() => {
        const params = new URLSearchParams(location.search); // Use URLSearchParams
        const savedPage = params.get("page");
        return savedPage ? Number(savedPage) : 1;
    }); // Pages are 1-indexed
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [paginationPage, setPaginationPage] = useState(0);
    const queryParams = new URLSearchParams(location.search);
    const queryString = new URLSearchParams(location.search).toString();

    useEffect(() => {
        setQuery(queryString);
        if (queryParams.get("page")) {
            setPaginationPage(Number(queryParams.get("page") - 1))
        } else {
            setPaginationPage(0);
        }
    }, [queryParams]);


    useEffect(() => {
        if (user_id) {
            dispatch(getPricingLeadStatus(token, user_id, identifier, queryParams.get("page") ?? 1, queryString));
        }
    }, [query, user_id, identifier]);

    let { loadingPricingLeadStatus, leadPricingStatusDataError, leadPricingStatusData, leadPricingStatusCurrentPage, leadPricingStatusTotalPage, leadPricingStatusTotalData, leadPricingAllStatusCount } = useSelector(state => state?.PricingLeadStatusReducer);

    const refreshData = () => {
        if (user_id) {
            dispatch(getPricingLeadStatus(token, user_id, identifier, queryParams.get("page") ?? 1, queryString));
            fetchMyQuotesCount();
            if (identifier?.includes("-my-quotes")) {
                fetchAllOtherCounts();
            }
        }
    };

    const openNewWindow = (url) => {
        const newWindow = window.open(
            url, // URL of the new window
            '_blank', // Target window name
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=600' // Window features
        );

        const interval = setInterval(() => {
            if (newWindow.closed) {
                clearInterval(interval);
                refreshData();
            }
        }, 500);
    };


    useEffect(() => {
        const handleMessage = (event) => {
            // Check for a specific event type or identifier
            if (event.data === 'refreshPricingTableData') {
                refreshData();
            }
        };

        // Add event listener to the window
        window.addEventListener('message', handleMessage);
        // Cleanup listener on component unmount
        return () => window.removeEventListener('message', handleMessage);
    }, []);



    const PickedQuotation = async (quotationId) => {
        try {
            const token = Cookies.get("token");
            const requesId = {
                quotation_id: `${quotationId}`,
            };
            const response = await fetch(`${adminMainUrl}/api/quotation/to_be_picked`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                    'user_id': user_id
                },
                body: JSON.stringify(requesId),
            });
            const data = await response.json();
            if (!response.ok) {
                toast.error(data?.msg);
                // throw new Error(`HTTP error! status: ${response.status}`);
            }
            toast.success(data?.msg);
            navigate('/flexichain/query-information', { state: { quotationId: quotationId } })
        } catch (error) {
            // toast.error(error);
            console.log(error);
        }
    };

    const AcceptRequest = async (quotationId) => {
        try {
            const token = Cookies.get("token");
            const requesId = {
                quotation_id: `${quotationId}`,
            };
            const response = await fetch(`${adminMainUrl}/api/pricing/accept-job`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                    "user_id": user_id,
                },
                body: JSON.stringify(requesId),
            });
            const data = await response.json();
            if (!response.ok) {
                toast.error(data?.msg);
                throw new Error(`HTTP error! status: ${response.status}`);

            }
            toast.success(data?.msg);
            // navigate('/flexichain/query-import-give-rates', { state: { quotationId: quotationId } });
            // navigate(`/flexichain/query-import-give-rate/${btoa(quotationId)}`);
            // window.open(`/flexichain/query-import-give-rate/${btoa(quotationId)}`);
            openNewWindow(`/flexichain/query-import-give-rate/${btoa(quotationId)}`);
            refreshData();
        } catch (error) {
            toast.error(error);
            console.log(error);
        }
    };




    useEffect(() => {

        if (loadingPricingLeadStatus) {
            setPageLoader(true);
        } else {
            setPageLoader(false);
        };

        if (leadPricingStatusData) {
            let arr = leadPricingStatusData?.map((value, i) => ({
                key: i + 1,
                sno: Number(paginationPage) * 10 + (i + 1),
                requestNo: value?.request_no,
                date: formatDate(value?.createdAt),
                name: (
                    <p className="d-flex align-items-center">
                        <span to="#" className="d-flex flex-column">
                            <span className="text-default">{value?.full_name}</span>
                        </span>
                    </p>
                ),
                email: value?.email,
                phoneNumber: value?.phone,
                // origin: value?.origin,   
                origin: value?.origin_type == "AIRPORT" ? `${value?.origin_port_full_name} ${value?.origin_type}` : `${value?.origin_address}, ${value?.origin_city ? value?.origin_city?.name : ""}, ${value?.origin_state ? value?.origin_state?.name : ""}, ${value?.origin_country ? value?.origin_country?.name : ""} (${value?.origin_type})`,
                // destination: value?.destination,
                destination: value?.destination_type == "AIRPORT" ? `${value?.destination_port_full_name} ${value?.origin_type}` : `${value?.destination_address}, ${value?.destination_city ? value?.destination_city?.name : ""}, ${value?.destination_state ? value?.destination_state?.name : ""}, ${value?.destination_country ? value?.destination_country?.name : ""} (${value?.origin_type})`,
                serviceType: value?.service_type ? value.service_type : "-",
                shipmentMode: capitalizeFirstLetter(value?.shipment_mode),
                // shipmentVia: value?.shipment_via?.name,
                pickedBySales: value?.picked_user ? value?.picked_user.name : "-",
                pickedBy: value?.pricing_user ? `${value?.pricing_user?.name}` : "-",
                action: (
                    <div className="dropdown table-action">
                        <Link to="#" className="action-icon" data-bs-toggle="dropdown" >
                            <i className="fa fa-ellipsis-v"></i>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-right">
                            <div className="dropdown-item" onClick={() => {
                                if (identifier === "air-import-requested" ||
                                    identifier === "ocean-import-requested" ||
                                    identifier === "courier-import-requested" ||
                                    identifier === "air-export-requested" ||
                                    identifier === "ocean-export-requested" ||
                                    identifier === "courier-export-requested") {
                                    AcceptRequest(value.id); // Hit the API only if filterTab is "all"
                                    // navigate('/flexichain/query-info-give-rates', { state: { quotationId: quotationId } });
                                } else if (identifier === "air-import-sent" ||
                                    identifier === "ocean-import-sent" ||
                                    identifier === "courier-import-sent" ||
                                    identifier === "air-export-sent" ||
                                    identifier === "ocean-export-sent" ||
                                    identifier === "courier-export-sent") {
                                    // navigate('/flexichain/view-price-information', { state: { quotationId: value?.id } });
                                    // navigate(`/flexichain/sent-query-quote/${btoa(value?.id)}`);
                                    openNewWindow(`/flexichain/sent-query-quote/${btoa(value?.id)}`);

                                } else {
                                    // Inprocess, My Quotes, Repricing
                                    openNewWindow(`/flexichain/query-import-give-rate/${btoa(value?.id)}`);
                                }
                            }}>
                                <i className="ti ti-eye text-blue-light"></i> Preview
                            </div>
                        </div>
                    </div>
                ),
            }));
            setDataSourcer(arr);
        }

        if (leadPricingStatusTotalData) {
            setTotalItems(leadPricingStatusTotalData);
        }

        if (leadPricingStatusTotalPage) {
            setTotalPages(leadPricingStatusTotalPage)
        }
        // console.log('------', usertype, shipment_mode, leadPricingAllStatusCount);
        if (leadPricingAllStatusCount) {
            applyStatusCounts(leadPricingAllStatusCount);
        }

        if (identifier?.includes("-my-quotes")) {
            setMyQuotesCount(leadPricingStatusTotalData ?? 0);
        }

    }, [loadingPricingLeadStatus, leadPricingStatusDataError, leadPricingStatusData, leadPricingStatusCurrentPage, leadPricingStatusTotalPage, leadPricingStatusTotalData, leadPricingAllStatusCount]);


    //pagination

    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        params.set("page", selectedPage);
        setCurrentPage(selectedPage);
        navigate(`?${params.toString()}`);
    };

    //search and filter data
    const parseQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            search_by: params.get("search_by") || "",
            request_no: params.get("request_no") || "",
            name: params.get("name") || "",
            email: params.get("email") || "",
            phone: params.get("phone") || "",
            origin: params.get("origin") || "",
            destination: params.get("destination") || "",
            shipment_type_id: params.get("shipment_type_id") || "",
            shipment_via_id: params.get("shipment_via_id") || "",
            required_servie_id: params.get("required_servie_id") || "",
            start_date: params.get("start_date") || "",
            end_date: params.get("end_date") || "",
            quotation_date: params.get("quotation_date") || "",
            filter_by: params.get("filter_by") || "",
            assign_branch_id: params.get("assign_branch_id") || params.get("branch_id") || (!hasFilterPermission && sidebarPermissionHRMSData?.branch_id ? String(sidebarPermissionHRMSData.branch_id) : "")
        };
    };

    let formik = useFormik({
        initialValues: parseQueryParams(),
        onSubmit: (values) => {
            const params = new URLSearchParams(location.search);
            Object.keys(values).forEach((key) => {
                if (values[key]) {
                    params.set(key, values[key]);
                } else {
                    params.delete(key);
                }
            });

            if (!params.has("page")) {
                params.set("page", "1");
            } else {
                params.set("page", "1");
            }
            const queryString = params.toString();
            navigate(`${location.pathname}?${queryString}`);
            const currentPage = 1;
            const ITEMS_PER_PAGE = 10;
            dispatch(getPricingLeadStatus(token, user_id, identifier, currentPage, queryString));
        },
    });

    useEffect(() => {
        if (!hasFilterPermission && formik && !formik.values.assign_branch_id) {
            if (sidebarPermissionHRMSData?.branch_id) {
                formik.setFieldValue("assign_branch_id", String(sidebarPermissionHRMSData.branch_id));
            } else if ((sidebarPermissionHRMSData?.branch_name || sidebarPermissionHRMSData?.branch) && branchList?.length > 0) {
                const bName = (sidebarPermissionHRMSData.branch_name || sidebarPermissionHRMSData.branch).trim().toLowerCase();
                const matched = branchList.find(b => b.label?.trim().toLowerCase() === bName);
                if (matched) {
                    formik.setFieldValue("assign_branch_id", String(matched.value));
                }
            }
        }
    }, [hasFilterPermission, sidebarPermissionHRMSData, branchList]);

    const resetFilters = () => {
        try {
            formik.setValues({
                search_by: "",
                request_no: "",
                name: "",
                email: "",
                phone: "",
                origin: "",
                destination: "",
                shipment_type_id: "",
                shipment_via_id: "",
                required_servie_id: "",
                start_date: "",
                end_date: "",
                quotation_date: "",
                filter_by: "",
                assign_branch_id: !hasFilterPermission && sidebarPermissionHRMSData?.branch_id ? String(sidebarPermissionHRMSData.branch_id) : ""
            });
            navigate(resetURL);
        } catch (error) {
            console.log(error.message);
            toast.error("Some error occured!");
        }
    };

    const resetFields = () => {
        setStatus_id('');
        setStartDate(null);
        setEndDate(null);
        setIsResetting(true);
        if (formik) {
            formik.setValues({
                search_by: "",
                request_no: "",
                name: "",
                email: "",
                phone: "",
                origin: "",
                destination: "",
                shipment_type_id: "",
                shipment_via_id: "",
                required_servie_id: "",
                start_date: "",
                end_date: "",
                quotation_date: "",
                filter_by: "",
                assign_branch_id: !hasFilterPermission && sidebarPermissionHRMSData?.branch_id ? String(sidebarPermissionHRMSData.branch_id) : ""
            });
        }
    };

    const handleStartDateChange = (date) => {
        if (date && date.getTime() === endDate?.getTime()) {
            alert("Start date and end date cannot be the same");
            return;
        }
        setStartDate(date);
        if (endDate && date && endDate.getTime() < date.getTime()) {
            setEndDate(null);
        }
    };
    const handleEndDateChange = (date) => {
        if (date && date.getTime() === startDate?.getTime()) {
            Swal.fire('Error', 'Start date and end date cannot be the same', 'error');
            return;
        }
        if (date && startDate && date.getTime() < startDate.getTime()) {
            Swal.fire('Error', 'End date cannot be before the start date', 'error');
            return;
        }
        setEndDate(date);
    };

    let { loadingPickedRateReqListApi, pickedRateReqListDataError, pickedRateReqListData, pickedRateReqListCurrentPage, pickedRateReqListTotalPage, pickedRateReqListTotalData } = useSelector(state => state?.PickedRateRequestReducer);

    useEffect(() => {

        if (pickedRateReqListData) {
            setList(pickedRateReqListData);
        }

        if (pickedRateReqListCurrentPage) {
            setCurrentPage(pickedRateReqListCurrentPage);
        }

        if (pickedRateReqListTotalData) {
            setTotalItems(pickedRateReqListTotalData);
        }

        if (pickedRateReqListTotalPage) {
            setTotalPages(pickedRateReqListTotalPage);
        }
    }, [loadingPickedRateReqListApi, pickedRateReqListDataError, pickedRateReqListData, pickedRateReqListCurrentPage, pickedRateReqListTotalPage, pickedRateReqListTotalData])

    return (
        <>
            {
                pageLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className={showSideNavBar ? "content" : "content m-3"}>
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Page Header */}
                                    <div className="page-header">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h4 className="page-title">
                                                    {headingText} <span className="count-title">{leadPricingStatusTotalData ? leadPricingStatusTotalData : 0}</span>
                                                </h4>
                                            </div>
                                            <div className="col-4 text-end">
                                                <div className="head-icons">
                                                    <a
                                                        href="javascript:void(0);"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        data-bs-original-title="Collapse"
                                                        id="collapse-header"
                                                    >
                                                        <i className="ti ti-chevrons-up" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /Page Header */}
                                </div>
                            </div>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="card">
                                    <div className="card-header py-2">
                                        {/* Search */}
                                        <div className="row align-items-center">
                                            <div className="col-sm-4">
                                                <div className="icon-form mb-3 mb-sm-0">
                                                    <span className="form-icon">
                                                        <i className="ti ti-search" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search "
                                                        name='search_by'
                                                        value={formik.values.search_by}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    // value={searchText}
                                                    // onChange={(e) => setSearchText(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-8">

                                                <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                                    <button type='submit' className="btn btn-primary me-2">
                                                        Search
                                                    </button>
                                                    <a
                                                        className='btn btn-primary me-2'
                                                        //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                                                        onClick={() => { resetFilters() }}
                                                    >
                                                        Clear
                                                    </a>

                                                    {/* <Link
                                                        to="/flexichain/quote-form"
                                                        className="btn btn-primary"
                                                    >
                                                        <i className="ti ti-square-rounded-plus me-2" />
                                                        Create Quote
                                                    </Link> */}
                                                </div>
                                            </div>
                                        </div>
                                        {/* /Search */}
                                    </div>
                                    <div className="card-body py-2">
                                        {/* Filter */}
                                        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                            <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                <div className="dropdown me-2">
                                                    <a
                                                        href="javascript:void(0);"
                                                        className="dropdown-toggle"
                                                        data-bs-toggle="dropdown"
                                                    >
                                                        <i className="ti ti-sort-ascending-2 me-2" />
                                                        Sort{" "}
                                                    </a>
                                                    <div className="dropdown-menu  dropdown-menu-start">
                                                        <ul>
                                                            <li>
                                                                <a href="javascript:void(0);" className="dropdown-item">
                                                                    <i className="ti ti-circle-chevron-right me-1" />
                                                                    Ascending
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);" className="dropdown-item">
                                                                    <i className="ti ti-circle-chevron-right me-1" />
                                                                    Descending
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);" className="dropdown-item">
                                                                    <i className="ti ti-circle-chevron-right me-1" />
                                                                    Recently Viewed
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);" className="dropdown-item">
                                                                    <i className="ti ti-circle-chevron-right me-1" />
                                                                    Recently Added
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="icon-form">
                                                    {/* <span className="form-icon">
                                                        <i className="ti ti-calendar" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control bookingrange"
                                                        placeholder=""
                                                    /> */}
                                                    <div className="input_box_section por_main_detail-date mb-0 d-sm-flex align-items-start gap-2">
                                                        <div className="input_box_section por_main_detail-date mb-0 custom-query-datepicker">
                                                            <DatePicker
                                                                dateFormat="dd/MM/yy"
                                                                placeholderText="From"
                                                                selected={startDate}
                                                                onChange={handleStartDateChange}
                                                                isClearable
                                                            />

                                                            {/* <span>
                                                                <img src="/img/date_icon.png" alt="Calendar" className='absolute-img' />
                                                            </span> */}
                                                        </div>
                                                        <div className="input_box_section por_main_detail-date mb-0 custom-query-datepicker">
                                                            <DatePicker
                                                                dateFormat="dd/MM/yy"
                                                                placeholderText="To"
                                                                selected={endDate}
                                                                onChange={handleEndDateChange}
                                                                isClearable
                                                            />
                                                            {/* <span>
                                                                <img src="/img/date_icon.png" alt="Calendar" className='absolute-img'/>
                                                            </span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center flex-wrap row-gap-2">

                                                <div className="form-sorts dropdown me-2">
                                                    <a
                                                        href="javascript:void(0);"
                                                        data-bs-toggle="dropdown"
                                                        data-bs-auto-close="outside"
                                                    >
                                                        <i className="ti ti-filter-share" />
                                                        Filter
                                                    </a>
                                                    <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                                                        <div className="filter-set-view">
                                                            <div className="filter-set-head">
                                                                <h4>
                                                                    <i className="ti ti-filter-share" />
                                                                    Filter
                                                                </h4>
                                                            </div>
                                                            <table className="content-table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            <label htmlFor="#">REQUEST NO.</label>
                                                                        </td>
                                                                        <td className="input_box_filter">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                placeholder="Enter Request No."
                                                                                name="request_no"
                                                                                value={formik.values.request_no}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            // value={status_id}
                                                                            // onChange={(e) => setStatus_id(e.target.value)}
                                                                            />
                                                                        </td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td>
                                                                            <label htmlFor="#">NAME</label>
                                                                        </td>
                                                                        <td className="input_box_filter">
                                                                            {" "}
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                placeholder="Enter Name"
                                                                                name="name"
                                                                                value={formik.values.name}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            // value={full_name}
                                                                            // onChange={(e) => setName(e.target.value)}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            <label htmlFor="#">EMAIL</label>
                                                                        </td>
                                                                        <td className="input_box_filter">
                                                                            {" "}
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                placeholder="Enter Email"
                                                                                name="email"
                                                                                value={formik.values.email}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            // value={email}
                                                                            // onChange={(e) => setEmail(e.target.value)}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    {
                                                                        hasFilterPermission && (
                                                                            <tr>
                                                                                <td>
                                                                                    <label htmlFor="#">BRANCH</label>
                                                                                </td>
                                                                                <td className="input_box_filter">
                                                                                    <Select
                                                                                        classNamePrefix="react-select"
                                                                                        placeholder="Select Branch"
                                                                                        options={branchList}
                                                                                        isClearable={hasFilterPermission}
                                                                                        isDisabled={!hasFilterPermission}
                                                                                        styles={{
                                                                                            container: (base) => ({
                                                                                                ...base,
                                                                                                width: '100%',
                                                                                            }),
                                                                                            control: (base, state) => ({
                                                                                                ...base,
                                                                                                height: '30px',
                                                                                                minHeight: '30px',
                                                                                                fontSize: '0.8rem',
                                                                                                borderRadius: '5px',
                                                                                                borderColor: '#E8E8E8',
                                                                                                boxShadow: state.isFocused ? 'none' : '0px 4px 4px 0px rgba(219, 219, 219, 0.25)',
                                                                                                backgroundColor: '#ffffff',
                                                                                                '&:hover': {
                                                                                                    borderColor: '#E8E8E8',
                                                                                                },
                                                                                            }),
                                                                                            valueContainer: (base) => ({
                                                                                                ...base,
                                                                                                height: '30px',
                                                                                                minHeight: '30px',
                                                                                                padding: '0 0.8rem',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                            }),
                                                                                            input: (base) => ({
                                                                                                ...base,
                                                                                                margin: 0,
                                                                                                padding: 0,
                                                                                                fontSize: '0.8rem',
                                                                                                color: '#6F6F6F',
                                                                                            }),
                                                                                            placeholder: (base) => ({
                                                                                                ...base,
                                                                                                fontSize: '0.8rem',
                                                                                                color: '#6c757d',
                                                                                                margin: 0,
                                                                                            }),
                                                                                            singleValue: (base) => ({
                                                                                                ...base,
                                                                                                fontSize: '0.8rem',
                                                                                                color: '#6F6F6F',
                                                                                                margin: 0,
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                            }),
                                                                                            indicatorsContainer: (base) => ({
                                                                                                ...base,
                                                                                                height: '30px',
                                                                                            }),
                                                                                            dropdownIndicator: (base) => ({
                                                                                                ...base,
                                                                                                padding: '0 6px',
                                                                                                svg: {
                                                                                                    width: '14px',
                                                                                                    height: '14px',
                                                                                                },
                                                                                            }),
                                                                                            clearIndicator: (base) => ({
                                                                                                ...base,
                                                                                                padding: '0 4px',
                                                                                                svg: {
                                                                                                    width: '14px',
                                                                                                    height: '14px',
                                                                                                },
                                                                                            }),
                                                                                            indicatorSeparator: () => ({
                                                                                                display: 'none',
                                                                                            }),
                                                                                            menu: (base) => ({
                                                                                                ...base,
                                                                                                fontSize: '0.8rem',
                                                                                                zIndex: 9999,
                                                                                            }),
                                                                                            option: (base) => ({
                                                                                                ...base,
                                                                                                fontSize: '0.8rem',
                                                                                                padding: '4px 8px',
                                                                                            }),
                                                                                        }}
                                                                                        value={formik.values.assign_branch_id ? branchList.find(opt => String(opt.value) === String(formik.values.assign_branch_id)) : null}
                                                                                        onChange={(opt) => {
                                                                                            if (opt) {
                                                                                                formik.setFieldValue("assign_branch_id", String(opt.value));
                                                                                            } else {
                                                                                                formik.setFieldValue("assign_branch_id", "");
                                                                                            }
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    }

                                                                    <tr>
                                                                        <td>
                                                                            <label htmlFor="#">ORIGIN</label>
                                                                        </td>
                                                                        <td className="input_box_filter">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                placeholder="Enter Origin"
                                                                                name="origin"
                                                                                value={formik.values.origin}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            />
                                                                        </td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td>
                                                                            <label htmlFor="#">DESTINATION</label>
                                                                        </td>
                                                                        <td className="input_box_filter">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                placeholder="Enter Destination"
                                                                                name="destination"
                                                                                value={formik.values.destination}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            />
                                                                        </td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td>
                                                                            <label htmlFor="#">PHONE</label>
                                                                        </td>
                                                                        <td className="input_box_filter">
                                                                            {" "}
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                placeholder="Enter Number"
                                                                                name="phone"
                                                                                value={formik.values.phone}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            // value={mobileNumber}
                                                                            // onChange={(e) => setMobileNumber(e.target.value)}
                                                                            />
                                                                        </td>
                                                                    </tr>

                                                                </tbody>
                                                            </table>

                                                            <div className="filter-reset-btns">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <a onClick={() => { resetFields() }} className="btn btn-light">
                                                                            Reset
                                                                        </a>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <button type='submit' className="btn btn-primary w-100">
                                                                            Filter
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="view-icons">
                                                    <Link onClick={() => { setGrid(true) }} className={`${grid === true && "active"}`}>
                                                        <i className="ti ti-list-tree" />
                                                    </Link>
                                                    <Link onClick={() => { setGrid(false) }} className={`${grid === false && "active"}`}>
                                                        <i className="ti ti-grid-dots" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        {/* /Filter */}

                                        {/* Contact List */}

                                        {showTabs && <div className='' style={{ width: "auto", overflowX: "auto", overflowY: "hidden", scrollBehavior: "smooth" }}>
                                            <ul className="nav mx-1 nav-pills nav-slider my-2 border-2 custom-tabs" id="pills-tab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <button onClick={() => { resetFilters(); navigate(`/flexichain/pricing/${shipment_mode}/${usertype}/rate-request/requested`) }} className={`nav-link fw-semibold custom-tab  ${(identifier == "air-import-requested" || identifier == "air-export-requested" || identifier == "ocean-import-requested" || identifier == "ocean-export-requested" || identifier == "courier-import-requested" || identifier == "courier-export-requested") && 'active'} position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Requested <span className="tab-count">{requestedCount}</span></button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button onClick={() => { resetFilters(); navigate(`/flexichain/pricing/${shipment_mode}/${usertype}/rate-request/my-quotes`) }} className={`nav-link fw-semibold custom-tab  ${(identifier == "air-import-my-quotes" || identifier == "air-export-my-quotes" || identifier == "ocean-import-my-quotes" || identifier == "ocean-export-my-quotes" || identifier == "courier-import-my-quotes" || identifier == "courier-export-my-quotes") && 'active'} position-relative`} id="my-quotes-tab" data-bs-toggle="pill" data-bs-target="#my-quotes" type="button" role="tab" aria-controls="my-quotes" aria-selected="true">My Pricing<span className="tab-count">{myQuotesCount}</span></button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button onClick={() => { resetFilters(); navigate(`/flexichain/pricing/${shipment_mode}/${usertype}/rate-request/inprocess`) }} className={`nav-link ${(identifier == "air-import-inprocess" || identifier == "air-export-inprocess" || identifier == "ocean-import-inprocess" || identifier == "ocean-export-inprocess" || identifier == "courier-import-inprocess" || identifier == "courier-export-inprocess") && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Inprocess <span className="tab-count">{inProcessCount}</span></button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button onClick={() => { resetFilters(); navigate(`/flexichain/pricing/${shipment_mode}/${usertype}/rate-request/sent`) }} className={`nav-link ${(identifier == "air-import-sent" || identifier == "air-export-sent" || identifier == "ocean-import-sent" || identifier == "ocean-export-sent" || identifier == "courier-import-sent" || identifier == "courier-export-sent") && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Sent <span className="tab-count">{sentCount}</span></button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button onClick={() => { resetFilters(); navigate(`/flexichain/pricing/${shipment_mode}/${usertype}/picked/repricing`) }} className={`nav-link fw-semibold custom-tab  ${(identifier == "air-import-repricing" || identifier == "air-export-repricing" || identifier == "ocean-import-repricing" || identifier == "ocean-export-repricing" || identifier == "courier-import-repricing" || identifier == "courier-export-repricing") && 'active'} fw-semibold custom-tab position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Repricing <span className="tab-count">{repricingCount}</span></button>
                                                </li>
                                            </ul>
                                        </div>}

                                        {showRepricingTabs && <div className='' style={{ width: "auto", overflowX: "auto", overflowY: "hidden", scrollBehavior: "smooth" }}>
                                            <ul className="nav mx-1 nav-pills nav-slider my-2 border-2 custom-tabs" id="pills-tab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <button onClick={() => { resetFilters(); navigate(`/flexichain/pricing/${shipment_mode}/${usertype}/picked/repricing`) }} className={`nav-link fw-semibold custom-tab  ${(identifier == "air-import-repricing" || identifier == "air-export-repricing" || identifier == "ocean-import-repricing" || identifier == "ocean-export-repricing" || identifier == "courier-import-repricing" || identifier == "courier-export-repricing") && 'active'} position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Repricing <span className="tab-count">{repricingCount}</span></button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button onClick={() => { resetFilters(); navigate(`/flexichain/pricing/${shipment_mode}/${usertype}/picked/inprocess`) }} className={`nav-link ${(identifier == "air-import-inprocess" || identifier == "air-export-inprocess" || identifier == "ocean-import-inprocess" || identifier == "ocean-export-inprocess" || identifier == "courier-import-inprocess" || identifier == "courier-export-inprocess") && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Inprocess <span className="tab-count">{inProcessCount}</span></button>
                                                </li>
                                            </ul>
                                        </div>}
                                        {
                                            grid ?

                                                <div className="table-responsive custom-table">
                                                    <Table className="table datanew dataTable no-footer"
                                                        // rowSelection={rowSelection} 
                                                        dataSource={dataSourcer}
                                                        columns={columns}
                                                        pagination={false} />
                                                </div> :
                                                <div className='row'>
                                                    {
                                                        leadPricingStatusData?.length > 0 ?
                                                            leadPricingStatusData?.map((value, i) => {
                                                                return (
                                                                    <div key={i} className="col-xxl-3 col-xl-4 col-md-6">
                                                                        <div className="card border">
                                                                            <div className="card-body">
                                                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                                                    <div className="d-flex align-items-center">
                                                                                        {/* <a
                                                                                            href="#"
                                                                                            className="avatar avatar-md flex-shrink-0 me-2"
                                                                                        >
                                                                                            <img
                                                                                                src="/assets/img/profiles/avatar-19.jpg"
                                                                                                alt="img"
                                                                                            />
                                                                                        </a> */}
                                                                                        <div>
                                                                                            <h6>
                                                                                                <a
                                                                                                    href="#"
                                                                                                    className="fw-medium"
                                                                                                >
                                                                                                    {value?.full_name}
                                                                                                </a>
                                                                                            </h6>
                                                                                            <p className="text-default">{value?.quotation_user_type}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="dropdown table-action">
                                                                                        <a
                                                                                            href="#"
                                                                                            className="action-icon "
                                                                                            data-bs-toggle="dropdown"
                                                                                            aria-expanded="false"
                                                                                        >
                                                                                            <i className="fa fa-ellipsis-v" />
                                                                                        </a>
                                                                                        <div className="dropdown-menu dropdown-menu-right">

                                                                                            <div className="dropdown-item" onClick={() => {
                                                                                                if (identifier === "air-import-requested" ||
                                                                                                    identifier === "ocean-import-requested" ||
                                                                                                    identifier === "courier-import-requested" ||
                                                                                                    identifier === "air-export-requested" ||
                                                                                                    identifier === "ocean-export-requested" ||
                                                                                                    identifier === "courier-export-requested") {
                                                                                                    AcceptRequest(value.id); // Hit the API only if filterTab is "all"
                                                                                                    // navigate('/flexichain/query-info-give-rates', { state: { quotationId: quotationId } });
                                                                                                } else if (identifier === "air-import-sent" ||
                                                                                                    identifier === "ocean-import-sent" ||
                                                                                                    identifier === "courier-import-sent" ||
                                                                                                    identifier === "air-export-sent" ||
                                                                                                    identifier === "ocean-export-sent" ||
                                                                                                    identifier === "courier-export-sent") {
                                                                                                    // navigate('/flexichain/view-price-information', { state: { quotationId: value?.id } });
                                                                                                    navigate(`/flexichain/sent-query-quote/${btoa(value?.id)}`);

                                                                                                } else {
                                                                                                    // Inprocess, My Quotes, Repricing
                                                                                                    openNewWindow(`/flexichain/query-import-give-rate/${btoa(value?.id)}`);
                                                                                                }
                                                                                            }}>
                                                                                                <i className="ti ti-eye text-blue-light"></i> Preview
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="d-block">
                                                                                    <div className="d-flex flex-column mb-3">
                                                                                        <p className="text-default d-inline-flex align-items-center mb-2">
                                                                                            <i className="ti ti-mail text-dark me-1" />
                                                                                            {value?.email}
                                                                                        </p>
                                                                                        <p className="text-default d-inline-flex align-items-center mb-2">
                                                                                            <i className="ti ti-phone text-dark me-1" />
                                                                                            {value?.phone}
                                                                                        </p>
                                                                                        <p className="text-default d-inline-flex align-items-center">
                                                                                            <i className="ti ti-map-pin-pin text-dark me-1" />
                                                                                            {value?.origin_type == "AIRPORT" ? `${value?.origin_port_full_name} ${value?.origin_type}` : `${value?.origin_address}, ${value?.origin_city ? value?.origin_city?.name : ""}, ${value?.origin_state ? value?.origin_state?.name : ""}, ${value?.origin_country ? value?.origin_country?.name : ""} `}
                                                                                        </p>
                                                                                        <p className="text-default d-inline-flex align-items-center">
                                                                                            <i className="ti ti-map-pin-pin text-dark me-1" />
                                                                                            {value?.origin_type == "AIRPORT" ? `${value?.destination_port_full_name} ${value?.origin_type}` : `${value?.destination_address}, ${value?.destination_city ? value?.destination_city?.name : ""}, ${value?.destination_state ? value?.destination_state?.name : ""}, ${value?.destination_country ? value?.destination_country?.name : ""} `}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span className="badge badge-tag badge-success-light me-2">
                                                                                            {value?.quote_status?.name}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }) :
                                                            <div className="box-grid">
                                                                No data available
                                                            </div>
                                                    }
                                                </div>
                                        }
                                        <div className="row align-items-center">
                                            {/* <div className="col-md-6">
                                            <div className="datatable-length" />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="datatable-paginate" />
                                        </div> */}
                                            {leadPricingStatusData?.length > 0 && <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1} // To sync ReactPaginate's internal state with currentPage
                                                />
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div >
                    </div >
            }


            {/* <CreateQuoteForm fetchQuotations={fetchQuotations} id="offcanvas_create" /> */}

            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} />
        </>

    )
}

export default PricingQuoteList